import { convertLabelsToTranslate } from '@/services/translate/translateMapper';

import service from '../../services';

const controlName = 'configTranslate';

export const messages = {
  defaultLabels: {
    Consultor: 'Consultor',
    consultor: 'consultor',
    CONSULTOR: 'CONSULTOR',
  },
  default126: {
    Consultor: 'Corretor',
    consultor: 'corretor',
    CONSULTOR: 'CORRETOR',
    'Produtos Obrigatórios': 'Coberturas Sugeridas',
    'Produtos Opcionais': 'Coberturas Opcionais',
    Regional: 'Corretora',
    regional: 'corretora',
    REGIONAL: 'CORRETORA',
    Regionais: 'Corretoras',
    Divisão: 'Assessoria',
    divisão: 'assessoria',
    DIVISÃO: 'ASSESSORIA',
    divisao: 'assessoria',
  },
  default128: {
    Consultor: 'Corretor',
    consultor: 'corretor',
    CONSULTOR: 'CORRETOR',
    'Produtos Obrigatórios': 'Coberturas Sugeridas',
    'Produtos Opcionais': 'Coberturas Opcionais',
    Regional: 'Corretora',
    regional: 'corretora',
    REGIONAL: 'CORRETORA',
    Regionais: 'Corretoras',
    Divisão: 'Assessoria',
    divisão: 'assessoria',
    DIVISÃO: 'ASSESSORIA',
    divisao: 'assessoria',
  },
};

export const getTranslate = async (companyId) => {
  const labels = await service.get(controlName, companyId);

  return (labels.length && convertLabelsToTranslate(labels)) || {};
};
